// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AutosubmitController from "./autosubmit_controller"
application.register("autosubmit", AutosubmitController)

import CinemaDropdownController from "./cinema_dropdown_controller"
application.register("cinema-dropdown", CinemaDropdownController)

import ConfirmController from "./confirm_controller"
application.register("confirm", ConfirmController)

import DatePickerController from "./date_picker_controller"
application.register("date-picker", DatePickerController)

import DirtyFormController from "./dirty_form_controller"
application.register("dirty-form", DirtyFormController)

import FileInputController from "./file_input_controller"
application.register("file-input", FileInputController)

import FilmMappingController from "./film_mapping_controller"
application.register("film-mapping", FilmMappingController)

import FilmSearchController from "./film_search_controller"
application.register("film-search", FilmSearchController)

import FocalImageController from "./focal_image_controller"
application.register("focal-image", FocalImageController)

import FocalPointController from "./focal_point_controller"
application.register("focal-point", FocalPointController)

import NavigationSelectController from "./navigation_select_controller"
application.register("navigation-select", NavigationSelectController)

import NotificationPreferenceController from "./notification_preference_controller"
application.register("notification-preference", NotificationPreferenceController)

import PrefetchLazyController from "./prefetch_lazy_controller"
application.register("prefetch-lazy", PrefetchLazyController)

import PullRefreshController from "./pull_refresh_controller"
application.register("pull-refresh", PullRefreshController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import SeatMapController from "./seat_map_controller"
application.register("seat-map", SeatMapController)

import SeatMapModalController from "./seat_map_modal_controller"
application.register("seat-map-modal", SeatMapModalController)

import SeatMapStreamController from "./seat_map_stream_controller"
application.register("seat-map-stream", SeatMapStreamController)

import ThemeController from "./theme_controller"
application.register("theme", ThemeController)

import TmdbPickerController from "./tmdb_picker_controller"
application.register("tmdb-picker", TmdbPickerController)

import ToastController from "./toast_controller"
application.register("toast", ToastController)

import ToggleController from "./toggle_controller"
application.register("toggle", ToggleController)

import WordmarkController from "./wordmark_controller"
application.register("wordmark", WordmarkController)
